module.exports = __webpack_public_path__ + "static/btn_022.471bb69a.png";